import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export async function downloadPdf(kind, id, name) {
  try {
    const r = await api.get(`/export/documents/${kind}/${id}.pdf`, { responseType: "blob" });
    const u = URL.createObjectURL(r.data);
    Object.assign(document.createElement("a"), { href: u, download: `${name || kind}.pdf` }).click();
    URL.revokeObjectURL(u);
  } catch (e) { toast.error(errMsg(e)); }
}

export function PdfButton({ kind, id, name, testid, size, className = "" }) {
  return (
    <Button variant="outline" size={size} data-testid={testid} onClick={() => downloadPdf(kind, id, name)} className={className}>
      <FileDown className={size === "icon" ? "h-4 w-4" : "me-1 h-4 w-4"} />{size !== "icon" && "PDF"}
    </Button>
  );
}
